import { render, staticRenderFns } from "./PlpProductHits.vue?vue&type=template&id=755a26b9&"
import script from "./PlpProductHits.vue?vue&type=script&lang=js&"
export * from "./PlpProductHits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PlpLoadPrevious: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/plp/PlpLoadPrevious.vue').default,ProductTileImageBanner: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/product-tile/ProductTileImageBanner.vue').default,PdpYotpoRating: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/pdp/PdpYotpoRating.vue').default,ProductTile: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/product-tile/ProductTile.vue').default,PlpLoadMore: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/plp/PlpLoadMore.vue').default})
